export const BLOCK_FEED_LIVE_TOPIC = "/blockfeed/live";

export const BLOCK_FEED_DELETE_LIVE_TOPIC = "/blockfeed/delete/live";

export const BLOCK_FEED_ACTION = "blocks";

export const CREATE_BLOCK_FEED_FILTER_ACTION = "createBlockFeedFilters";
export const GET_BLOCK_FEED_FILTERS_ACTION = "getBlockFeedFilters";
export const UPDATE_BLOCK_FEED_FILTER_ACTION = "updateBlockFeedFilter";
export const DELETE_BLOCK_FEED_FILTER_ACTION = "deleteBlockFeedFilters";

export const BLOCK_TYPE_FUTURE = "Future";

export const BLOCK_TYPE_OPTION = "Option";

export const MONTH_CODES: Record<string, string> = {
  F: "Jan",
  G: "Feb",
  H: "Mar",
  J: "Apr",
  K: "May",
  M: "Jun",
  N: "Jul",
  Q: "Aug",
  U: "Sep",
  V: "Oct",
  X: "Nov",
  Z: "Dec",
};

export const STRATEGY_TYPE_MAP: Record<string, string> = {
  "3W": "3-Way",
  "3C": "3-Way Straddle versus Call",
  "3P": "3-Way Straddle versus Put",
  BX: "Box",
  FB: "Bundle",
  BF: "Butterfly",
  BO: "Butterfly",
  SD: "Calendar",
  DG: "Calendar Diagonal",
  HO: "Calendar Horizontal",
  EQ: "Calendar Spread",
  CF: "Condor",
  CO: "Condor",
  CV: "Covered",
  FX: "Deferred Calendar Spread",
  DB: "Double",
  DF: "Double Butterfly",
  GN: "Generic",
  GT: "Guts",
  HS: "Horizontal Straddle",
  IS: "Intercommodity",
  IB: "Iron Butterfly",
  IC: "Iron Condor",
  JR: "Jelly Roll",
  PK: "Pack",
  PS: "Pack Spread",
  "12": "Ratio 1x2",
  "13": "Ratio 1x3",
  "23": "Ratio 2x3",
  SP: "Standard Calendar Spread",
  ST: "Straddle",
  SS: "Straddle Strip",
  SG: "Strangle",
  SA: "Strip",
  SR: "Strip",
  FS: "Strip Spread",
  VT: "Vertical",
  XT: "Xmas Tree",
  FO: "Pending guidance from PLCT",
  PB: "Pack Butterfly",
  MP: "Month Pack",
};
